export type DrivingLicence = 'FULLUK' | 'PROVISIONALUK' | 'EUROPEAN' | 'INTERNATIONAL' | 'NONE' | 'UNKNOWN'

export const mapToDrivingLicence = (drivingLicence: string | undefined): DrivingLicence => {
  switch (drivingLicence?.toLowerCase()) {
    case 'full uk driving licence':
      return 'FULLUK'
    case 'provisional uk driving licence':
      return 'PROVISIONALUK'
    case 'european driving licence':
      return 'EUROPEAN'
    case 'international driving licence':
      return 'INTERNATIONAL'
    case 'no driving licence':
      return 'NONE'
    default:
      return 'UNKNOWN'
  }
}
